import { SimplifiedUserProduct } from "../../Models/Product";
import api from "../axios";

export const tenantFeaturedProductService = {
  getFeatured: async (): Promise<string[]> => {
    const res = await api.get("/tenant-featured-product");
    return res.data; // Array of productIds
  },

  getFeaturedProducts: async (): Promise<SimplifiedUserProduct[]> => {
    const res = await api.get("/tenant-featured-product/products");
    return res.data;
  },

  setFeatured: async (productIds: string[]): Promise<boolean> => {
    const res = await api.put("/tenant-featured-product", productIds);
    return res.data;
  }
};
